import { connect, MapStateToProps } from 'react-redux';
import { Props } from './DisabledOrPrivateInfo';
import { CommentableTypes } from '../../../Comment/redux/types';
import { getDeviationById } from '../../../redux/deviations/selectors';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { getCurrentUser } from '../../../publicSession/selectors';

export type StateProps = Pick<
  Props,
  | 'folderId'
  | 'subproductId'
  | 'isPaidFolder'
  | 'authorName'
  | 'commentsDisabledForAllUsers'
  | 'user'
>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (
  state,
  { commentableItemId, commentableType }
) => {
  if (commentableType === CommentableTypes.COMMENT_DEVIATION) {
    const deviation = getDeviationById(state, commentableItemId);
    if (deviation) {
      const authorName = deviation?.author?.username;
      const { folderId, isPremium, isPaidFolder, subproductId } =
        normalizePremiumFolderData(deviation?.premiumFolderData);

      if (!isPremium || !deviation.hasPrivateComments) {
        return { commentsDisabledForAllUsers: true };
      }

      return {
        commentsDisabledForAllUsers: false,
        folderId,
        subproductId,
        isPaidFolder,
        authorName,
        user: getCurrentUser(state),
      };
    }
  }

  return { commentsDisabledForAllUsers: true };
};

export default connect(mapStateToProps);
